import { z } from 'zod';
import { BaseEventSchema } from './Base';

export const LoginErrorBaseSchema = BaseEventSchema.extend({
  error: z.any().nullable().optional(),
  method: z.enum(['biometric', 'verification_code']),
  type: z.enum(['phone', 'email']).nullable(),
});

export const AddressNotInDeliveryZoneSchema = BaseEventSchema.extend({
  street: z.string(),
  street_number: z.string().nullable(),
  commune: z.string().nullable(),
});

export const ErrorAddressCreateEventSchema = BaseEventSchema.extend({
  street: z.string(),
  street_number: z.string(),
  commune: z.string(),
  apartment: z.string(),
  instructions: z.string(),
});

export const ErrorContactMekiEventSchema = BaseEventSchema.extend({
  error: z.enum(['REGISTRY_ERROR', 'OTHER_ERROR']),
  payment_method_type: z.enum(['FINTOC', 'ONE PAY']),
});

export const ErrorPaymentEventSchema = BaseEventSchema.extend({
  error: z.any(),
  error_type: z.enum(['']).nullable().optional(),
  type: z.enum(['BANCO_ESTADO', 'FINTOC', 'LOCAL']),
});

export const SessionEventSchema = BaseEventSchema.extend({
  type: z.enum(['phone', 'email']),
  phone_number: z.string().nullable(),
  email: z.string().nullable(),
  error: z.any(),
  is_auth_error: z.boolean(),
});

export const SessionBiometricLoginEventSchema = BaseEventSchema.extend({
  error: z.string(),
});

export const PrescriptionUploadErrorEventSchema = BaseEventSchema.extend({
  error: z.enum(['document_size', 'unsupported_file', 'unknown']),
});

export enum ErrorEventTypes {
  AddressNotInDeliveryZone = 'error.address.not_in_delivery_zone',
  AddressCreate = 'error.address.create',
  ContactMeki = 'error.contact_meki',
  // Payment
  Payment = 'error.payment',
  PaymentCancel = 'error.payment.cancel',
  // Session
  SessionVerificationCodeNotSent = 'error.session.verification_code_not_sent',
  SessionBiometricLogin = 'error.session.biometric_login',
  SessionLoginAttempt = 'error.session.login',
  SessionMissingUserInfo = 'error.session.missing_user_info',
  // Prescriptions
  PrescriptionsUploadError = 'error.prescriptions.upload',
}

export const ErrorEventTrackingSchemas = {
  [ErrorEventTypes.AddressNotInDeliveryZone]: AddressNotInDeliveryZoneSchema,
  [ErrorEventTypes.AddressCreate]: ErrorAddressCreateEventSchema,
  [ErrorEventTypes.ContactMeki]: ErrorContactMekiEventSchema,
  // Payment
  [ErrorEventTypes.Payment]: ErrorPaymentEventSchema,
  [ErrorEventTypes.PaymentCancel]: ErrorPaymentEventSchema,
  // Session
  [ErrorEventTypes.SessionVerificationCodeNotSent]: SessionEventSchema,
  [ErrorEventTypes.SessionBiometricLogin]: SessionEventSchema,
  [ErrorEventTypes.SessionLoginAttempt]: LoginErrorBaseSchema,
  [ErrorEventTypes.SessionMissingUserInfo]: BaseEventSchema,
  // Prescriptions
  [ErrorEventTypes.PrescriptionsUploadError]:
    PrescriptionUploadErrorEventSchema,
} as const;
